import { usePanelWidth } from './usePanelWidth';

const DOCUMENTATION_PANEL_CONFIG = {
  storageKey: 'documentationDependenciesPanelWidth',
  defaultWidth: 464,
  minWidth: 464,
  maxWidth: 850,
};

export const useDocumentationPanelWidth = () => {
  return usePanelWidth(DOCUMENTATION_PANEL_CONFIG);
};
